var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"popover"}},[_c('div',{ref:"popover",class:_vm.popoverClass},[_c('div',{staticClass:"tooltip-container",class:{'tooltip-active': _vm.isVisible},style:(_vm.tooltipStyle)},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }